import {Dce, DceHTMLElement} from "dce-engine";
import Fragment, {FragmentProps} from "./Fragment";
import {FragmentAction, KnownActionData} from "./ajax/AjaxResponse";

interface ModalFragmentProps extends FragmentProps {
    url?: string;
    title: string;
}

@Dce("ModalFragment")
export default class ModalFragment extends Fragment {

    public closeHandler: (actions: FragmentAction<keyof KnownActionData>[]) => void;
    public passToOpenerHandler: (actions: FragmentAction<keyof KnownActionData>[]) => void;

    constructor(elem: DceHTMLElement, props: ModalFragmentProps) {
        super(elem, props);

        setTimeout(() => this.elem.setAttribute("data-modal-state", "active"), 10);

        this.elem.querySelectorAll('[data-ref="close"]').forEach(elem => {
            elem.addEventListener('click', e => {
                this.close();
            })
        })

    }

    registerCalls() {
        this.registerCall("close", (a) => this.closeCall(a));
        this.registerCall("passToOpener", (a) => this.passToOpenerHandler(a));
    }

    public onClose(closeHandler: (actions: FragmentAction<keyof KnownActionData>[]) => void) {
        this.closeHandler = closeHandler;
    }

    public onPassToOpener(handler: (actions: FragmentAction<keyof KnownActionData>[]) => void) {
        this.passToOpenerHandler = handler;
    }

    public passToOpenerCall(actions: FragmentAction<keyof KnownActionData>[]) {
        if (this.passToOpenerHandler) {
            this.passToOpenerHandler(actions);
        }
    }

    public closeCall(actions: FragmentAction<keyof KnownActionData>[]) {

        this.elem.setAttribute("data-modal-state", "active");

        setTimeout(() => this.elem.remove(), 300);

        if (this.closeHandler) {
            this.closeHandler(actions);
        }
    }

    public close() {
        //this.elem.classList.remove("active");

        this.elem.setAttribute("data-modal-state", null);

        setTimeout(() => this.elem.remove(), 300);
    }

    public closeWithSaveEvent() {
        let actions: FragmentAction<"uievent">[] = [];
        actions.push({
            type: "uievent",
            data: {
                e: "saved"
            }
        });

        this.passToOpenerHandler(actions);
        this.close();
    }

}
